import { useSortable } from "@dnd-kit/sortable";
import type { ReactNode } from "react";

interface SortableItemProps {
  id: string;
  children: ReactNode;
  disabled?: boolean;
}

export function SortableItem(props: SortableItemProps) {
  const { id, children, disabled = false } = props;
  const { setNodeRef, transform, transition } = useSortable({ id, disabled });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition,
      }}
    >
      {children}
    </div>
  );
}
